import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import { Button, IconButton } from '@onefootprint/ui';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
type WhatsNewBannerProps = {
  open: boolean;
  onWhatsNewOpen: () => void;
  onDismiss: () => void;
};
const WhatsNewBanner = t0 => {
  const $ = _c(8);
  const {
    open,
    onWhatsNewOpen,
    onDismiss
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav.whatsNew.banner"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== onDismiss || $[2] !== onWhatsNewOpen || $[3] !== open || $[4] !== t) {
    t2 = open && <motion.div className="flex flex-col gap-5 w-full box-border border border-tertiary px-5 py-4 rounded-default bg-elevated relative" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.2
    }}><div className="flex flex-col gap-2"><div className="absolute right-1 top-1"><IconButton aria-label={t(_temp)} onClick={onDismiss} size="compact" icon={IcoCloseSmall16} /></div><p className="text-label-2">{t(_temp2)}</p><p className="text-body-2 text-secondary">{t(_temp3)}</p></div><Button variant="secondary" onClick={onWhatsNewOpen}>{t(_temp4)}</Button></motion.div>;
    $[1] = onDismiss;
    $[2] = onWhatsNewOpen;
    $[3] = open;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default WhatsNewBanner;
function _temp($) {
  return $.dismiss;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.subtitle;
}
function _temp4($_2) {
  return $_2.seeUpdates;
}